"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioConfig = exports.RadioDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.FieldConfigDefinition;
});

var OptionsElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionsElementDefinition;
});

var RadioDefinition = _flowRuntime["default"].type("RadioDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(OptionsElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("radio")), _flowRuntime["default"].property("value", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("confirmText", _flowRuntime["default"].string(), true))));

exports.RadioDefinition = RadioDefinition;
var radioConfig = {
  type: 'radio',
  normalize: 'boolean'
};
exports.radioConfig = radioConfig;